/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from 'lodash';

interface ObjWithPartyId {
  partyId: number;
}

export interface FunctionTypes {
  choosePartyPanelProfileTab(tabName: string): BaseTockAction;
  deselectParty(): BaseTockAction;
  selectParty(partyIdObj: ObjWithPartyId, selectOriginatedAt?: string): BaseTockAction;
  selectPartyAndShowProfile(partyId: number): void;
  toggleIsAssigningTables(): BaseTockAction;
  toggleNewAssigningSession(): BaseTockAction;
}

export function choosePartyPanelProfileTab(tabName: any): BaseTockAction {
  return {
    type: 'SELECT_PARTY_PANEL_PROFILE_TAB',
    payload: tabName,
  };
}

export function deselectParty(): BaseTockAction {
  return {
    type: 'DESELECT_PARTY',
  };
}

export function selectParty(
  { partyId }: { partyId: number },
  selectOriginatedAt: any
): BaseTockAction {
  return {
    type: 'SELECT_PARTY',
    payload: partyId,
    context: {
      shouldTrack: !_.isNil(selectOriginatedAt), // Only track if we have the info on where the select originated
      selectOriginatedAt,
      keyToTrack: 'context.selectOriginatedAt',
    },
  };
}

export function selectPartyAndShowProfile(partyId: number): BaseTockAction {
  return {
    type: 'SELECT_PARTY_AND_VIEW_PROFILE',
    payload: partyId,
  };
}

export function toggleIsAssigningTables(): BaseTockAction {
  return {
    type: 'TOGGLE_IS_ASSIGNING_TABLES',
  };
}

export function toggleNewAssigningSession(): BaseTockAction {
  return {
    type: 'TOGGLE_NEW_ASSIGNING_SESSION',
  };
}
